/* eslint-disable */
// this is an auto generated file. This will be overwritten
export const deleteClient = `mutation DeleteClient($input: DeleteClientInput!) {
  deleteClient(input: $input) {
    id
  }
}
`;

export const createClient = `mutation CreateClient($input: CreateClientInput!) {
  createClient(input: $input) {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    accounts {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        lastUpdated
        version
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    version
  }
}
`;

export const createAccount = `mutation CreateAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdated
    version
  }
}
`;
export const updateAccount = `mutation UpdateAccount($input: UpdateAccountInput!) {
  updateAccount(input: $input) {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdated
  }
}
`;
export const deleteAccount = `mutation DeleteAccount($input: DeleteAccountInput!) {
  deleteAccount(input: $input) {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdated
    version
  }
}
`;

// Stream Router Interface Mutations
export const createStreamRouterInterface = `mutation CreateStreamRouterInterface($streamRouterId: String!, $interfaceData: StreamRouterInterfaceCreateInput!) {  createStreamRouterInterface(streamRouterId: $streamRouterId, interfaceData: $interfaceData) {    success    message    dataJson  }}`;
export const updateStreamRouterInterface = `mutation UpdateStreamRouterInterface($streamRouterId: String!, $interfaceId: String!, $interfaceData: StreamRouterInterfaceUpdateInput!) {  updateStreamRouterInterface(streamRouterId: $streamRouterId, interfaceId: $interfaceId, interfaceData: $interfaceData) {    success    message    dataJson  }}`;
export const deleteStreamRouterInterface = `mutation DeleteStreamRouterInterface($streamRouterId: String!, $interfaceId: String!) {  deleteStreamRouterInterface(streamRouterId: $streamRouterId, interfaceId: $interfaceId) {    success    message    dataJson  }}`;
// Wowza Mutations
export const createExternalWowzaTarget = `mutation CreateExternalWowzaTarget($serverId: String!, $applicationId: String!, $targetConfig: WowzaTargetConfigInput!) {  createExternalWowzaTarget(serverId: $serverId, applicationId: $applicationId, targetConfig: $targetConfig) {    success    message    dataJson  }}`;
export const updateExternalWowzaTarget = `mutation UpdateExternalWowzaTarget($serverId: String!, $applicationId: String!, $targetId: String!, $targetConfig: WowzaTargetConfigInput!) {  updateExternalWowzaTarget(serverId: $serverId, applicationId: $applicationId, targetId: $targetId, targetConfig: $targetConfig) {    success    message    dataJson  }}`;
export const deleteExternalWowzaTarget = `mutation DeleteExternalWowzaTarget($serverId: String!, $applicationId: String!, $targetId: String!) {  deleteExternalWowzaTarget(serverId: $serverId, applicationId: $applicationId, targetId: $targetId) {    success    message    dataJson  }}`;
